<template>
  <div class="receipt-detail-drawer">
    <finance-drawer
      title="客户详情"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="currentItem.customerNo"
      :modal-close="false"
      @open="handleOpen"
      @refresh="handleRefresh"
      :is-fixed-h="true"
    >
      <div slot="fixed-drawer-header">
        <div class="title-header">
          <div class="detail-title-name">
            {{currentItem.businessAbbrName || '-'}}
          </div>
          <div class="title-icon">
            <icon-status
              :color="currentItem.status | setStatusColor('servicerStatus')"
              :status="currentItem.statusDesc"
            />
          </div>
        </div>
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane
            label="基本信息"
            name="baseInfo"
          />
          <el-tab-pane
            label="联系人信息"
            name="contactInfo"
          />
          <el-tab-pane
            label="银行卡信息"
            name="bankInfo"
          />
        </el-tabs>
      </div>
      <div class="main-cont">
        <base-info
          ref="baseInfo"
          v-if="activeName === 'baseInfo'"
          :customer-no="currentItem.customerNo"
        />
        <contact-info
          ref="contactInfo"
          v-if="activeName === 'contactInfo'"
          :customer-no="currentItem.customerNo"
        />
        <bank-info
          ref="bankInfo"
          v-if="activeName === 'bankInfo'"
          :businessName="currentItem.businessName"
          :customer-no="currentItem.customerNo"
        />
      </div>
    </finance-drawer>
  </div>
</template>
<script>
import baseInfo from './base-info';
import contactInfo from './contact-info';
import bankInfo from './bank-info';

export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { baseInfo, contactInfo, bankInfo },
  data() {
    return {
      activeName: 'baseInfo',
    };
  },
  watch: {
    'currentItem.customerNo': {
      deep: true,
      handler() {
        if (this.currentItem.customerNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 打开窗口
    handleOpen() {
      this.activeName = 'baseInfo';
      this.$nextTick(() => {
        this.getDetail();
      });
    },
    // 刷新
    handleRefresh() {
      this.getDetail();
    },
    // 获取详情
    async getDetail() {
      this.$refs[this.activeName].init();
    },
    // tabs切换
    handleClick() {
      this.$nextTick(() => {
        this.$refs[this.activeName].init();
      });
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .main-cont {
    padding: 0;
  }
  .drawer-body {
    padding: 0 32px !important;
  }
  .el-tabs__item:focus.is-active.is-focus:not(:active) {
    border: none;
    box-shadow: none;
  }
}
.title-header {
  display: flex;
  justify-content: space-between;
  .title-icon {
    position: relative;
  }
}
</style>

